import Promise from 'bluebird';
import actionTypes from './action_types';
import ChromecastManager from '../services/chromecast/chromecast_manager';
import { addNotification } from './notifications';

export default class DeviceActions {
  static NUM_RETRIES = 20;
  static RETRY_INTERVAL = 1000 * 2; // 2 seconds

  constructor(deviceService) {
    this._deviceService = deviceService;
  }

  loadDevices() {
    return (dispatch, getState) => {
      const userId = this.getUserId(getState());

      return this._deviceService.loadDevices(userId).then(({ devices }) => {
        return dispatch({
          type: actionTypes.DEVICES_LOADED,
          payload: { devices },
        });
      });
    };
  }

  pairDevice(code, name) {
    return (dispatch, getState) => {
      let deviceId;

      return this._deviceService
        .pairDevice(code, name)
        .then(({ device }) => {
          if (!device) {
            return dispatch(addNotification('Invalid pair code.'));
          }

          deviceId = device.id;

          return dispatch({
            type: actionTypes.DEVICE_PAIR_STARTED,
          });
        })
        .then(() => {
          if (!deviceId) {
            return null;
          }

          const userId = this.getUserId(getState());

          return this.pollPairStatus(deviceId, userId, DeviceActions.NUM_RETRIES, dispatch);
        });
    };
  }

  pairChromecast() {
    // Automatically pair devices, Skipping the manual inputing of a pair code.
    // This reverses the usual flow of the TV generating the code
    // and the Dashboard then resending it to the server.
    // --viktor@2017-09-15

    return (dispatch) => {
      let pairCode;

      return (
        this._deviceService
          .requestPairCode()
          .then(({ device }) => {
            pairCode = device.pairCode;

            return ChromecastManager.sendMessage({
              subject: 'AUTH_CODE',
              payload: { pairCode },
            });
          })
          // XXX: Do not use a hardcoded value for device name. --viktor@2017-09-15
          .then(() => dispatch(this.pairDevice(pairCode, 'Chromecast device')))
      );
    };
  }

  unpairDevice(deviceId) {
    return (dispatch, getState) => {
      const userId = this.getUserId(getState());

      return this._deviceService.unpairDevice(deviceId, userId).then(() =>
        dispatch({
          type: actionTypes.DEVICE_UNPAIRED,
          payload: { deviceId },
        }),
      );
    };
  }

  getUserId(state) {
    if (state.guest.invite) {
      return state.guest.invite.userId;
    }

    return state.auth.user.id;
  }

  pollPairStatus(deviceId, userId, numRetries, dispatch) {
    return this._deviceService.checkPairStatus(deviceId, userId).then(({ device }) => {
      return Promise.resolve().then(() => {
        if (device) {
          return dispatch({
            type: actionTypes.DEVICE_PAIR_SUCCEEDED,
            payload: { device },
          });
        }

        if (numRetries > 0) {
          return Promise.delay(DeviceActions.RETRY_INTERVAL).then(() =>
            this.pollPairStatus(deviceId, userId, numRetries - 1, dispatch),
          );
        }

        dispatch({ type: actionTypes.DEVICE_PAIR_FAILED });
        dispatch(addNotification('Device failed to pair.'));

        return null;
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/device_actions.js